import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	completeButton: {
		id: 'polaris-components-quickstart.task-complete-button.got-it.non-final',
		defaultMessage: 'Got it',
		description:
			'The button that appears below the task description in the list of onboarding tasks in the sidebar',
	},
});
